import { toString } from 'lodash';
import * as LoggingConstants from '../constants/LoggingConstants';

export const ComponentStateActions = {
    SET_TEXT_BOX_FOCUSED: '@@universalsearch/SET_TEXT_BOX_FOCUSED',
    SET_INPUT_STRING: '@@universalsearch/SET_INPUT_STRING',
    NEXT_OPTION: '@@universalsearch/NEXT_OPTION',
    PREVIOUS_OPTION: '@@universalsearch/PREVIOUS_OPTION',
    SET_FOCUS_INDEX: '@@universalsearch/SET_FOCUS_INDEX',
    SET_CURRENT_SEARCH_QUERY: '@@universalsearch/SET_CURRENT_SEARCH_QUERY',
    SET_FIRST_SECTION: '@@universalsearch/SET_FIRST_SECTION',
    SET_SECOND_SECTION: '@@universalsearch/SET_SECOND_SECTION',
    SET_THIRD_SECTION: '@@universalsearch/SET_THIRD_SECTION',
    ENABLE_BROWSE_SPECIALTY: '@@universalsearch/ENABLE_BROWSE_SPECIALTY',
    SET_POPULAR_SPECIALTIES: '@@universalsearch/SET_POPULAR_SPECIALTIES',
    SET_ALL_SPECIALTIES: '@@universalsearch/SET_ALL_SPECIALTIES',
};

export const setTextBoxFocused = focused => ({
    type: ComponentStateActions.SET_TEXT_BOX_FOCUSED,
    focused,
});

export const setInputString = inputString => ({
    type: ComponentStateActions.SET_INPUT_STRING,
    inputString,
});

export const nextOption = () => ({
    type: ComponentStateActions.NEXT_OPTION,
});

export const previousOption = () => ({
    type: ComponentStateActions.PREVIOUS_OPTION,
});

export const setFocusIndex = index => ({
    type: ComponentStateActions.SET_FOCUS_INDEX,
    index,
});

export const setCurrentSearchQuery = query => ({
    type: ComponentStateActions.SET_CURRENT_SEARCH_QUERY,
    query,
});

export const setFirstSection = data => ({
    type: ComponentStateActions.SET_FIRST_SECTION,
    data,
});

export const setSecondSection = data => ({
    type: ComponentStateActions.SET_SECOND_SECTION,
    data,
});

export const setThirdSection = data => ({
    type: ComponentStateActions.SET_THIRD_SECTION,
    data,
});

export const enableBrowseSpecialty = () => ({
    type: ComponentStateActions.ENABLE_BROWSE_SPECIALTY,
});

export const setPopularSpecialties = data => ({
    type: ComponentStateActions.SET_POPULAR_SPECIALTIES,
    data,
});

export const setAllSpecialties = data => ({
    type: ComponentStateActions.SET_ALL_SPECIALTIES,
    data,
});

export function populateBrowseSpecialties() {
    return (dispatch, getState) => {
        if (!getState().universalSearch.componentState.browseSpecialtyEnabled) {
            return;
        }

        return fetchBrowseSpecialties()
            .then(specialties => dispatch(setBrowseSpecialties(specialties)))
            .then(() => dispatch(setSectionsWithBrowseSpecialties()))
            .catch(err => {
                if (process.env.NODE_ENV === 'development') {
                    console.log(err); // eslint-disable-line no-console
                }
            });
    };
}


const apiHost = process.env.API_HOST || '';
const getSpecialtyDropdownEndpoint = () => `${apiHost}/api/2/specialty/dropdowncontents`;

function fetchBrowseSpecialties() {
    return fetch(getSpecialtyDropdownEndpoint())
        .then(response => {
            if (response.status >= 400) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('Bad response from server'); // eslint-disable-line no-console
                }
            }

            return response.json();
        })
    // eslint-disable-next-line no-console
        .catch(err => console.error(err));
}

function setBrowseSpecialties(response) {
    if (process.env.NODE_ENV === 'development') {
        console.log(response.data); // eslint-disable-line no-console
    }

    return dispatch => {
        dispatch(setPopularSpecialties(formatSpecialties(response.data.popular_specialties)));
        dispatch(setAllSpecialties(formatSpecialties(response.data.specialties)));
    };
}

export function setSectionsWithBrowseSpecialties() {
    return (dispatch, getState) => {
        if (getState().universalSearch.componentState.inputString.length === 0) {
            dispatch(setFirstSection(getState().universalSearch.componentState.popularSpecialties));
            dispatch(setSecondSection(getState().universalSearch.componentState.allSpecialties));
        }
    };
}

function formatSpecialties(monolithSpecialties) {
    return monolithSpecialties.map(specialty => {
        return {
            name: specialty.specialty_name,
            id: toString(specialty.specialty_id),
            specialtyId: toString(specialty.specialty_id),
            specialtyName: specialty.specialty_name,
            procedureId: toString(specialty.default_procedure_id),
            procedureName: specialty.default_procedure_name,
            dataSource: LoggingConstants.browseSpecialtyType,
        };
    });
}
